import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C3PortfoliosEdit } from "./edit";
import { C3PortfoliosNew } from "./new";
import { C3PortfoliosTable } from "./table";
export default function C5Portfolios() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portefeuilles");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<C3PortfoliosEdit />} />
      <Route index element={<C3PortfoliosTable />} />
      <Route path="/new" element={<C3PortfoliosNew />} />
    </Routes>
  );
}
